import { Box, Button, TextField, Typography, useTheme } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useSelector } from "react-redux";
import { requester } from "api/pesabackend";

const DepartmentCreateForm = ({ setOpen, setNewDepartmentData, setIsSuccess }) => {
  const theme  = useTheme();
  const isDark = theme.palette.mode === "dark";

  const accent  = theme.palette.secondary.main;
  const textSec = theme.palette.neutral.main;
  const border  = isDark ? "rgba(29,158,117,0.14)" : "rgba(29,158,117,0.16)";

  const userId          = useSelector((s) => s.authReducer.user.userId);
  const business_id     = useSelector((s) => s.authReducer.business_id);
  const business_branch_id = useSelector((s) => s.authReducer.business_branch_id);

  const fieldSx = {
    "& .MuiInputBase-root": { fontSize: "13px", borderRadius: "8px" },
    "& .MuiOutlinedInput-notchedOutline": { borderColor: border },
    "& .MuiInputLabel-root": { fontSize: "13px" },
    "& .MuiFormHelperText-root": { fontSize: "11px" },
  };

  const saveItem = async (values, onSubmitProps) => {
    const res = await requester.post("/human_resource/departments", JSON.stringify({
      ...values,
      related_business: business_id,
      related_business_branch: business_branch_id,
      added_by: userId,
    }));
    if (res.data.status === 201) {
      setOpen(false);
      setNewDepartmentData(true);
      onSubmitProps.resetForm();
      setIsSuccess(true);
    }
  };

  return (
    <Formik
      onSubmit={(values, helpers) => saveItem(values, helpers)}
      initialValues={{ department_name: "" }}
      validationSchema={yup.object().shape({ department_name: yup.string().required("Department name is required") })}
    >
      {({ values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>

            <Box>
              <Typography sx={{ fontSize: "10px", fontWeight: 500, letterSpacing: "0.07em", textTransform: "uppercase", color: textSec, mb: "6px" }}>
                Department Name
              </Typography>
              <TextField
                fullWidth
                placeholder="e.g. Finance, Operations, HR…"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.department_name}
                name="department_name"
                error={Boolean(touched.department_name) && Boolean(errors.department_name)}
                helperText={touched.department_name && errors.department_name}
                size="small"
                sx={fieldSx}
              />
            </Box>

            <Button
              type="submit"
              disabled={isSubmitting}
              fullWidth
              sx={{
                fontSize: "13px", fontWeight: 500,
                py: "0.6rem", borderRadius: "8px",
                textTransform: "none",
                backgroundColor: accent, color: "#fff",
                "&:hover": { backgroundColor: "#0F6E56" },
              }}
            >
              Save Department
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default DepartmentCreateForm;